import ModelTypeConstants from 'constants/ModelTypeConstants';
import FileStates from 'FileStates';
import APIUtil from 'util/APIUtil';

/** Whether FileBrowserActions.openFile can open the item in the app. */
export default function canOpenFile(fileId: string): boolean {
  const fileType = APIUtil.apiIdToMaybeType(fileId);
  if (fileType == null) {
    return false;
  }
  // Specially handled cases in FileBrowserActions.openFile.
  if (fileType === ModelTypeConstants.FOLDER || fileType === ModelTypeConstants.CHAT_SESSION) {
    return true;
  }
  return FileStates.get().getFileState(fileId) != null;
}
